import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './sensor-data.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const SensorDataDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const sensorDataEntity = useAppSelector(state => state.sensorData.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sensorDataDetailsHeading">
          <Translate contentKey="fleetSenseApp.sensorData.detail.title">SensorData</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{sensorDataEntity.id}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="fleetSenseApp.sensorData.value">Value</Translate>
            </span>
          </dt>
          <dd>{sensorDataEntity.value}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.sensorData.created">Created</Translate>
            </span>
          </dt>
          <dd>{sensorDataEntity.created ? <TextFormat value={sensorDataEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.sensorData.sensor">Sensor</Translate>
          </dt>
          <dd>{sensorDataEntity.sensor ? sensorDataEntity.sensor.description : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.sensorData.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{sensorDataEntity.truckImplement ? sensorDataEntity.truckImplement.licensePlate : ''}</dd>
          {/* <dt>
            <Translate contentKey="fleetSenseApp.sensorData.company">Company</Translate>
          </dt>
          <dd>{sensorDataEntity.company ? sensorDataEntity.company.name : ''}</dd> */}
          <dt>
            <Translate contentKey="fleetSenseApp.sensorData.user">User</Translate>
          </dt>
          <dd>{sensorDataEntity.user ? sensorDataEntity.user.login : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.sensorData.vehiclePosition">Vehicle Position</Translate>
          </dt>
          <dd>{sensorDataEntity.vehiclePosition ? sensorDataEntity.vehiclePosition.created : ''}</dd>
        </dl>
        <Button tag={Link} to="/sensor-data" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sensor-data/${sensorDataEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SensorDataDetail;
